import { Button, ButtonSize, ButtonVariant, Icon, IconVariants, Switch, Text, TextVariants } from "@next-platform/client-common-spicy-ui";

import { Row } from "@/components";
import { cn } from "@/utils";

import { GENERAL_SEETING_TYPE, SettingsItemProps } from "./types";

const GeneralSettingsItem = ({ title, subtitle, type, value, icon, disabled, onClick }: SettingsItemProps) => {
  const isActionable = type !== GENERAL_SEETING_TYPE.TEXT && !disabled;

  return (
    <div
      className={cn("flex gap-md items-center py-3 border-b border-gray-800", disabled && "cursor-not-allowed", isActionable && "cursor-pointer")}
      onClick={() => isActionable && onClick?.()}
    >
      <div>
        <Icon icon={icon} className={cn(disabled && "opacity-[0.5]")} />
      </div>
      <div className="flex flex-col">
        <Text variant={TextVariants.LABEL_LARGE_REGULAR} className={cn("text-gray-12", disabled && "opacity-[0.5]")}>
          {title}
        </Text>
        {subtitle ? (
          <Text variant={TextVariants.LABEL_SMALL_REGULAR} className={cn("text-gray-11", disabled && "opacity-[0.5]")}>
            {subtitle}
          </Text>
        ) : null}
      </div>
      {/* Right Side Actions */}
      <div className="ml-auto">
        {type === GENERAL_SEETING_TYPE.BUTTON && (
          <Button disabled={disabled} size={ButtonSize.LARGE} variant={ButtonVariant.SECONDARY} className={cn(disabled && "!cursor-not-allowed")}>
            {value}
          </Button>
        )}
        {type === GENERAL_SEETING_TYPE.TOGGLE && (
          <div
            onClick={(event) => {
              event.stopPropagation();
            }}
          >
            <Switch
              disabled={disabled}
              checked={value as boolean}
              className={cn(disabled && "!cursor-not-allowed")}
              onCheckedChange={() => {
                if (!disabled) {
                  onClick?.();
                }
              }}
            />
          </div>
        )}

        {type === GENERAL_SEETING_TYPE.MODAL && (
          <Row className="gap-md cursor-pointer">
            {value ? (
              <Text variant={TextVariants.LABEL_MEDIUM_REGULAR} className="text-gray-11">
                {value}
              </Text>
            ) : null}
            <Icon icon={IconVariants.CHEVRON_RIGHT} />
          </Row>
        )}

        {type === GENERAL_SEETING_TYPE.TEXT && value ? (
          <Text variant={TextVariants.LABEL_MEDIUM_REGULAR} className="text-gray-11">
            {value}
          </Text>
        ) : null}
      </div>
    </div>
  );
};

export default GeneralSettingsItem;
